/**
 * Tracking Events
 * This file is used to track events on the QMS app.
 * It listens to custom events and sends the data to Shopify's analytics.
 * All data should be prepared and sent in the format that Shopify's analytics expects.
 */

const allLinks = document.querySelectorAll(`a[href="${window.urlTracking}"]`);
allLinks.forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();

    const ecommerceData = {
      page_location: window.location.href,
      button_url: link.href,
      button_value: link.innerText,
    };
    Shopify.analytics.publish('urlClicked', ecommerceData);

    // Ensures that the data is sent to Shopify's analytics before the user is redirected
    setTimeout(() => {
      window.location.href = link.href;
    }, 1);
  });
});
